import defaultState from './defaultState'
import { actionTypes } from '../../../actions/src'

const featureImageReducer = (state = { ...defaultState }, { type, payload }) => {

  const imageState = payload ? state[payload.uniqueKey] : {}
  switch (type) {

    case actionTypes.FEATURE_IMAGE_PROCESSING:
      return { ...state,
        [payload.uniqueKey]: {
          ...imageState,
          isImageProcessing: true,
          isImageCompleted: false,
          hasImageFailed: false
        }
      }
    case actionTypes.FEATURE_IMAGE_COMPLETED:
      return { ...state,
        [payload.uniqueKey]: {
          ...imageState,
          isImageProcessing: false,
          isCheckingImageStatus: false,
          isImageCompleted: true,
          checkSettled: true,
          hasImageFailed: false,
          cdnUrl: payload.cdnUrl
        }
      }
    case actionTypes.FEATURE_IMAGE_NOT_FOUND:
      return { ...state,
        [payload.uniqueKey]: {
          ...imageState,
          isImageProcessing: false,
          isCheckingImageStatus: false,
          isImageCompleted: false,
          checkSettled: true,
          hasImageFailed: false
        }
      }
    case actionTypes.FEATURE_IMAGE_CLEAR_LOOP_CHECK:
      return { ...state,
        [payload.uniqueKey]: {
          ...imageState,
          isImageProcessing: false,
          isCheckingImageStatus: false,
          timerCheckLoop: undefined,
          hasImageFailed: false
        }
      }
    case actionTypes.FEATURE_IMAGE_REQUESTING_STATUS:
      return { ...state,
        [payload.uniqueKey]: {
          ...imageState,
          isCheckingImageStatus: true,
          timerCheckLoop: payload.data,
          imageNotFound: false,
          checkSettled: false,
          hasImageFailed: false
        }
      }
    case actionTypes.FEATURE_IMAGE_READY:
      return { ...state,
        [payload.uniqueKey]: {
          ...imageState,
          isImageProcessing: false,
          isCheckingImageStatus: false,
          isImageCompleted: false,
          checkSettled: true,
          hasImageFailed: false
        }
      }
    case actionTypes.FEATURE_IMAGE_FAILED:
      return { ...state,
        [payload.uniqueKey]: {
          ...imageState,
          isImageProcessing: false,
          isCheckingImageStatus: false,
          isImageCompleted: false,
          hasImageFailed: true,
          checkSettled: true
        }
      }

    default:
      return state

  }

}

export default featureImageReducer
